export const URL = process.env.VUE_APP_BACKEND_URL;
export const ADDRESS_API = process.env.VUE_APP_GET_ADDRESS;
export const MEDIA = 'https://digitalpress-prod.s3.eu-west-2.amazonaws.com/media/';